module.exports = false;


//////////////////
// WEBPACK FOOTER
// C:/Software Development/Devpark/biz-app/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 6